import { useDropzone } from 'react-dropzone';

import UploadIcon from 'assets/icons/upload.svg';

export interface DropZoneProps {
  onDrop: (acceptedFiles: File[]) => void;
}

function DropZone(props: DropZoneProps) {
  const {
    getRootProps, getInputProps, isDragActive, isDragReject,
  } = useDropzone({
    onDrop: props.onDrop,
    accept: {
      'text/csv': ['.csv'],
    },
  });

  return (
    <div
      className={`ct_dropzone ${isDragActive ? '_active' : ''} ${isDragReject ? '_rejected' : ''}`}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      {!isDragReject && (
        <>
          <div className="ct_dropzone-icon">
            <UploadIcon />
          </div>
          <div className="ct_dropzone-msg">
            Drag & drop or
            {' '}
            <span className="ct_dropzone-highlight">choose file</span>
          </div>
        </>
      )}

      {isDragReject && (
        <>
          <div className="ct_dropzone-icon">
            <UploadIcon />
          </div>
          <div className="ct_dropzone-msg">Please select .csv file </div>
        </>
      )}
    </div>
  );
}

export default DropZone;
